// apply patch to resolve "Current environment does not allow unsafe-eval"
import {BulgePinchFilter} from '@pixi/filter-bulge-pinch';
import {install} from '@pixi/unsafe-eval';
import FontFaceObserver from 'fontfaceobserver';
import * as PIXI from 'pixi.js';

install(PIXI);

class PixiScene {
  constructor($element) {
    this.$element = $element;
    this.$container = $element.querySelector('.homepageVisionContainer');
    this.textX = 0;
  }

  startAnimation() {
    if (this.isAnimating) return;

    if (this.isInitialized) {
      this.isAnimating = true;
      this.animate();
    } else {
      this.initialize();
    }
  }

  stopAnimation() {
    this.isAnimating = false;
  }

  showView() {
    this.$container.style.opacity = 1;
  }

  hideView() {
    this.$container.style.opacity = 0;
  }

  initialize() {
    // initialize only once
    if (this.isInitialized || this.isInitializing) return;

    this.height = Math.round( window.innerHeight / 3);
    this.width = window.innerWidth;
    this.bindLoading();
    this.isInitializing = true;
  }

  bindLoading() {
    this.font = new FontFaceObserver('FormaDisplay', {});

    this.font.load().then(() => {
      this.initApp();
      this.initText();
      this.initBulge();
      this.isInitializing = false;
      this.isAnimating = true;
      this.isInitialized = true;
      this.animate();
    }, () => {
      // eslint-disable-next-line
      console.error('Unable to load required font!');
    });
  }

  initApp() {
    this.app = new PIXI.Application({
      width: this.width,
      height: this.height,
      backgroundAlpha: 0,
    });

    this.app.view.classList.add('homepageVisionCanvas');
    this.$container.appendChild(this.app.view);

    this.view = new PIXI.Container();
    this.app.stage.addChild(this.view);
  }

  initBulge() {
    const isMinQueryM = window.innerWidth >= 769;
    this.view.filters = [new BulgePinchFilter({
      x: 0.5,
      y: 0.5,
      radius: isMinQueryM ? 350 : 150,
      strength: 0.4,
    })];
    this.view.filterArea = this.app.screen;
  }

  initText() {
    this.$title = this.$element.querySelector('.homepageVisionText');
    this.text = new PIXI.Text(this.$title.textContent, {
      fontFamily: 'FormaDisplay',
      fontSize: ((window.innerWidth * 10) / 100) + 'px',
      fill: 'white',
      padding: 100,
    });
    this.text.anchor.set(0, 0.5);
    this.text.resolution = 4;

    this.view.addChild(this.text);
  }

  animate() {
    this.render();

    if (this.isAnimating) {
      window.requestAnimationFrame(this.animate.bind(this));
    }
  }

  render() {
    // update text position
    this.text.position.set(this.textX, this.height / 2);
    this.app.render(this.view);
  }

  setTextX(x) {
    this.textX = x;
  }

  unmount() {
    this.stopAnimation();
  }
}

export default PixiScene;
